import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { kirimCatatAkses, lupakanAkses } from '../../utils/catatAkses';

// Dipasang sekali di dalam router: setiap perpindahan halaman oleh pengguna yang login dicatat di Log Aktivitas (lihat utils/catatAkses.js).
const CatatAkses = () => {
  const { pathname } = useLocation();
  const uuid = useSelector((state) => state.auth?.user?.uuid);

  useEffect(() => {
    if (uuid) kirimCatatAkses(pathname);
  }, [pathname, uuid]);

  // Pengguna berganti / logout: catatan "sudah dikirim" dilupakan supaya akun berikutnya dicatat dari awal.
  useEffect(() => lupakanAkses, [uuid]);

  return null;
};

export default CatatAkses;
